export default __webpack_public_path__ + "static/media/Niro.b3e8fdb2.png";